module.exports = __webpack_public_path__ + "img/searchScreen.f333c5b6.png";